import { CdkCell, CdkCellDef, CdkColumnDef, CdkFooterCell, CdkFooterCellDef, CdkFooterRow, CdkFooterRowDef, CdkHeaderCell, CdkHeaderCellDef, CdkHeaderRow, CdkHeaderRowDef, CdkRow, CdkRowDef, } from '@angular/cdk/table';
export var NbCdkRowDef = CdkRowDef;
export var NbCdkRow = CdkRow;
export var NbCdkCellDef = CdkCellDef;
export var NbCdkHeaderRowDef = CdkHeaderRowDef;
export var NbCdkHeaderRow = CdkHeaderRow;
export var NbCdkHeaderCellDef = CdkHeaderCellDef;
export var NbCdkFooterRowDef = CdkFooterRowDef;
export var NbCdkFooterRow = CdkFooterRow;
export var NbCdkFooterCellDef = CdkFooterCellDef;
export var NbCdkColumnDef = CdkColumnDef;
export var NbCdkCell = CdkCell;
export var NbCdkHeaderCell = CdkHeaderCell;
export var NbCdkFooterCell = CdkFooterCell;
//# sourceMappingURL=type-mappings.js.map